/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  SeekButton,
  Text,
} from './SeekStyles';
import { usePlayer } from '../../../PlayerContext';
import { useOptions } from '../../../OptionsContext';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

function FastForward({ isMini }) {
  const player = usePlayer();
  const { seekStepInSeconds } = useOptions();

  const rights = useSelector(state => state.playback.rights);
  const isPlayingDaiAds = useSelector(state => state.playback.isPlayingDaiAds);

  const disabled = (isPlayingDaiAds && !rights.adsFastForward) || (!isPlayingDaiAds && !rights.fastForward) || false;
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);

  const fastForward = () => {
    if (!disabled) {
      player.fastForward(seekStepInSeconds);
    }
  };

  return (
    <SeekButton
      enabled={!disabled}
      isMini={isMini}
      isMobile={isMobile}
      viewBox="0 0 29 32"
      onClick={fastForward}
      data-cy="hp-seek-forward-button"
    >
      <g fill="none">
        <path d="M0-1h28v28H0z" />
        <Text x="8" y="22">
          {seekStepInSeconds}
        </Text>
        <path d="M14.4993 31.9167C18.1736 31.9167 21.3276 30.6962 23.9613 28.2552C26.595 25.8143 28.0531 22.7952 28.3358 19.1979C28.3615 18.8896 28.2651 18.6198 28.0467 18.3886C27.8283 18.1573 27.5521 18.0417 27.2181 18.0417C26.9097 18.0417 26.6464 18.1509 26.428 18.3693C26.2096 18.5877 26.0747 18.8639 26.0233 19.1979C25.7406 22.1528 24.5073 24.6259 22.3233 26.6172C20.1393 28.6085 17.5313 29.6042 14.4993 29.6042C11.2875 29.6042 8.55749 28.48 6.30922 26.2318C4.06096 23.9835 2.93683 21.2535 2.93683 18.0417C2.93683 14.8299 4.02884 12.0998 6.21287 9.85158C8.3969 7.60331 11.0948 6.47918 14.3066 6.47918H15.1545L13.1504 8.48335C12.9191 8.7146 12.8035 8.98439 12.8035 9.29272C12.8035 9.60106 12.9191 9.87085 13.1504 10.1021C13.3816 10.3333 13.6514 10.449 13.9597 10.449C14.2681 10.449 14.5379 10.3333 14.7691 10.1021L18.816 6.05522C18.9445 5.92675 19.0344 5.79828 19.0858 5.66981C19.1372 5.54134 19.1629 5.40002 19.1629 5.24585C19.1629 5.09168 19.1372 4.95036 19.0858 4.82189C19.0344 4.69342 18.9445 4.56495 18.816 4.43647L14.7306 0.351058C14.525 0.145502 14.2681 0.0427246 13.9597 0.0427246C13.6514 0.0427246 13.3816 0.145502 13.1504 0.351058C12.9448 0.582308 12.842 0.852099 12.842 1.16043C12.842 1.46877 12.9448 1.72571 13.1504 1.93127L15.3858 4.16668H14.4993C12.5722 4.16668 10.7672 4.5264 9.08422 5.24585C7.40124 5.96529 5.93023 6.95453 4.6712 8.21356C3.41217 9.47259 2.42294 10.9436 1.7035 12.6266C0.984053 14.3096 0.624329 16.1146 0.624329 18.0417C0.624329 19.9688 0.984053 21.7738 1.7035 23.4568C2.42294 25.1398 3.41217 26.6108 4.6712 27.8698C5.93023 29.1288 7.40124 30.1181 9.08422 30.8375C10.7672 31.557 12.5722 31.9167 14.4993 31.9167Z" fill="white" />
      </g>
    </SeekButton>
  );
}

FastForward.propTypes = {
  isMini: PropTypes.bool,
};

export default React.memo(FastForward);
